import { FC, useState } from "react";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import FlexContent from "../../../../ui/FlexContent";
import ModalDialog from "../../../../ui/ModalDialog";
import ClampingForm from "./ClampingForm";

const CreateClampingModalDialogButton: FC = () => {
  const i18n = useI18n();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>{i18n.translation.common.createNew}</Button>
      {showNewItemDialog && (
        <ModalDialog
          onClose={() => setShowNewItemDialog(false)}
          title={i18n.translation.patrolSystemMappings.createNew}
        >
          <FlexContent direction="row">
            <ClampingForm onSave={() => setShowNewItemDialog(false)} />
          </FlexContent>
        </ModalDialog>
      )}
    </>
  );
};

export default CreateClampingModalDialogButton;
